import { DistrictStudentAssignment } from "types";
import * as Types from "./types";

export const isDSA = (
  assignment: Omit<Types.SectionAssignment, "assignStatus">,
): assignment is DistrictStudentAssignment =>
  assignment.type === "districtStudentAssignment";

export const compareCallback: Types.CompareCallback = (a, b) => {
  if (!a.dueOn && b.dueOn) {
    return 1;
  }
  if (a.dueOn && !b.dueOn) {
    return -1;
  }
  if (a.dueOn === b.dueOn) {
    if (isDSA(a) && isDSA(b)) {
      if (a.startedAt > b.startedAt) {
        return 1;
      }
      if (a.startedAt < b.startedAt) {
        return -1;
      }
    }
    if (!isDSA(a) && !isDSA(b)) {
      if (a.startOn > b.startOn) {
        return 1;
      }
      if (a.startOn < b.startOn) {
        return -1;
      }
    }
  }
  // eslint-disable-next-line
  return a.dueOn > b.dueOn ? 1 : b.dueOn > a.dueOn ? -1 : 0;
};
